<template>
  <custom-dialog width="560px" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <el-form :model="form" :inline="true" :rules="rules" ref="form">
        <el-form-item :label="$t('crm_contract_lease_dialog.falxmc')" prop="categoryName">
          <el-input placeholder v-model="form.categoryName" style="width: 480px"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button size="small" type="primary" @click="confirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';
import languageInjectMixins from '@/mixins/language_inject_mixins.js';

export default {
  mixins: [languageInjectMixins, dialogMixins],
  data() {
    return {
      form: {
        categoryId: '',
        parentId: '',
        categoryName: '',
      },
    };
  },
  computed: {
    rules() {
      return {
        categoryName: [
          { required: true, message: this.$t('crm_contract_lease_dialog.qtxfalxmc') },
          { max: 50, message: this.$t('Common.com_rules_length_max', [50]) },
        ],
      };
    },
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    // 初始化
    initDialog: function () {
      if (this.model.type === 'add') {
        this.form.parentId = this.model.data.parentId || '';
      }
      if (this.model.type === 'edit') {
        this.$setFormatData(this.form, this.model.data);
      }
    },
    // 确认保存
    confirm: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        if (this.model.type === 'add') {
          this.saveInsert();
        }
        if (this.model.type === 'edit') {
          this.saveUpdate();
        }
      });
    },
    // 保存新增
    saveInsert: function () {
      this.$postJSON(apis.CategoryAdd, this.form).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.$emit('success');
        this.visible = false;
      });
    },
    // 保存编辑
    saveUpdate: function () {
      this.$postJSON(apis.CatgoryUpdate, this.form).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.$emit('success', this.form);
        this.visible = false;
      });
    },
  },
};
</script>

<style lang="scss"></style>
